<template>
  <div id="page">
    <hero></hero>
    <feature></feature>
    <pricing></pricing>
  </div>
</template>

<script>
import Hero from '../components/Hero'
import Feature from '../components/Feature'
import Pricing from '../components/Pricing'

export default {
  components: {
    Hero,
    Feature,
    Pricing,
  },
    metaInfo: { 
        title: null,
        meta: [
          {
            name: 'description',
            content: 'Bringing Analytics to Small and Medium Businesses. We provide you with the infrastructure and reports to gain insight into your data.'
          }
        ]
        },
}
</script>
